import 'slick-carousel';

const $ = jQuery;

export default {
    init() {
        setupCaseStudyCarousel();
    }
};

function setupCaseStudyCarousel() {
    const $blocks = $('.block-case-study-carousel');

    if (!$blocks.length) {
        return;
    }

    $blocks.each(function() {
        const $container = $(this);
        const $slider = $container.find('.case-study-slider');
        const $prevArrow = $container.find('.case-study-prev-custom');
        const $nextArrow = $container.find('.case-study-next-custom');
        const $wrapper = $container.find('.alignment-wrapper');

        if ($slider.hasClass('slick-initialized')) {
            return;
        }

        const updateAlignment = (nextSlideIndex) => {
            if (window.innerWidth < 1024) {
                $wrapper.css('margin-left', '');
                return;
            }

            if (nextSlideIndex === 0) {
                $wrapper.css('margin-left', '0px');
            } else {
                const currentPadding = $wrapper.css('padding-left');
                $wrapper.css('margin-left', '-' + currentPadding);
            }
        };

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            updateAlignment(nextSlide);
        });

        $slider.on('breakpoint', function(event, slick) {
            updateAlignment(slick.currentSlide);
        });

        $(window).on('resize', function() {
            if (window.innerWidth < 1024) {
                $wrapper.css('margin-left', '');
            } else {
                const currentSlide = $slider.slick('slickCurrentSlide');
                updateAlignment(currentSlide);
            }
        });

        $slider.slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            variableWidth: false,

            swipeToSlide: true,
            touchThreshold: 100,
            useCSS: true,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                        arrows: false,
                        touchThreshold: 20
                    }
                }
            ]
        });
    });
}
